import type { SttMode } from '@kiao-voice/core'
export interface VoiceStreamingDecision {
  enabled: boolean
  relayUrl: string
}

/**
 * Decide whether a dictation streams to the relay, and which relay URL to use.
 *
 * Server-driven: stream iff the server's `sttMode` is realtime-capable (the active
 * STT model, surfaced by /voice-usage/me). The relay URL prefers the
 * server-advertised value (voiceRelayUrl), falling back to the env/default so local
 * dev works without the API advertising one.
 */
export function resolveVoiceStreamingDecision(input: {
  serverSttMode?: SttMode
  serverRelayUrl?: string | null
  envRelayUrl: string
}): VoiceStreamingDecision {
  const relayUrl = input.serverRelayUrl?.trim() || input.envRelayUrl
  return { enabled: input.serverSttMode === 'realtime', relayUrl }
}
